import { useEffect, useState } from 'react'
import { productsApi } from '../services/api'

/**
 * Les produits mis en avant, charges une fois pour toute la page d'accueil.
 *
 * Un seul consommateur aujourd'hui : la promotion de l'application, dont
 * l'ecran de telephone affichait « Salon Prestige 5P, 4 200 000 GNF » avec
 * une image Unsplash. Ce produit n'existe pas et ce prix n'a jamais ete
 * pratique ; l'ecran montre desormais une vraie fiche du catalogue.
 *
 * L'ouverture en dependait aussi, le temps de sortir les trois photos de
 * banque d'images de son carrousel. Elle montre maintenant les
 * photographies d'ABBUSINESS et n'appelle plus rien. Le partage de la
 * promesse reste : il ne coute rien, et il redeviendra utile des qu'une
 * deuxieme section aura besoin des memes produits. Sans lui, deux GET
 * identiques partiraient, ce que le cache HTTP masque la plupart du temps
 * et pas toujours.
 *
 * Une reponse est reutilisee pendant une minute. Au-dela, un nouveau montage
 * recharge : le temps de vie est court exprimes, une mise en avant changee
 * dans l'administration ne doit pas survivre a la navigation.
 */

const PARAMETRES = { featured: 1, per_page: 4, sort: 'featured' }
const DUREE_DE_VIE = 60_000

let requete = null
let expiration = 0

function charger() {
  if (requete && Date.now() < expiration) return requete

  expiration = Date.now() + DUREE_DE_VIE
  requete = productsApi.list(PARAMETRES).catch((erreur) => {
    /*
     | Un echec ne se met pas en cache. Sans cette remise a zero, une
     | coupure reseau d'une seconde au chargement condamnerait la section
     | pour toute la duree de la visite.
     */
    requete = null
    expiration = 0
    throw erreur
  })

  return requete
}

export function useVedettes() {
  const [vedettes, setVedettes] = useState([])
  const [chargement, setChargement] = useState(true)

  useEffect(() => {
    let annule = false

    charger()
      .then((res) => { if (! annule) setVedettes(res.data ?? []) })
      .catch(() => { if (! annule) setVedettes([]) })
      .finally(() => { if (! annule) setChargement(false) })

    return () => { annule = true }
  }, [])

  return { vedettes, chargement }
}

/** Le premier produit mis en avant qui a une photo, ou null. */
export function premiereVedetteIllustree(vedettes) {
  return vedettes.find((p) => p.primary_image) ?? null
}
